<!--
 * @Description: 
 * @Author:  
 * @Date: 2022-07-25 10:14:20
 * @LastEditTime: 2024-05-15 16:31:23
 * @LastEditors:  
-->
<template lang="html">
  <div class="no-container">
    <div class="img-group">
      <img :src="$store.state.static_img_url + 'pic/pc3.5/404.png'">
      <div class="desc-p">
        <p>找不到页面？</p>
        <p>别担心，<span>动脉网APP</span>带您发现更多精彩。</p>
        <p>下载APP，探索海量医疗资讯，高效对接产业资源。</p>
      </div>
    </div>
    <a :href="$store.state.index2_path  + '/new'" class="btn">返回首页</a>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="stylus" scoped>
.no-container
  padding 100px 0
  min-height calc(100vh - 64px)
  display flex
  flex-direction column
  align-items center
  justify-content center
  .img-group
    position: relative
    img
      height 250px
    .desc-p
      margin-top 20px
      text-align center
      p
        font-size 22px
        color #333333
        line-height 36px
        span
          color #FA5A00
  a
    margin: 30px auto 0
    display: block
    background: #FA5A00
    width: 150px
    height: 44px
    border-radius:22px
    box-shadow: 0px 8px 16px 0px rgba(17,93,170,0.15)
    color: #FFFFFF
    font-size: 16px
    line-height: 44px
    text-align: center
    &:hover
      background: #FF4800
</style>
